<template>
  <div class="breadcrumb-block">
    <ul class="breadcrumb-block__list">
      <li
        v-for="(crumb, index) in allLinks"
        :key="index"
        class="breadcrumb-block__list-item d-none d-sm-none d-md-block"
      >
        <span
          class="breadcrumb-block__divisor"
          v-if="index"
        >
          /
        </span>
        <span
          v-if="crumb.current"
          class="breadcrumb-block__list-item__link breadcrumb-block__list-item--active"
        >
          {{ crumb.name }}
        </span>
         <ZLink
          v-else
          :href="crumb.url"
          class="breadcrumb-block__list-item__link breadcrumb-block__list-item__link--no-active"
        >
          {{ crumb.name }}
         </ZLink>
      </li>
      <li class="breadcrumb-block__list-item d-md-none">
        <ZLink
         :href="lastElement.url"
         class="breadcrumb-block__list-item__link breadcrumb-block__list-item__link--no-active"
        >
          <img src="~/assets/images/icons/breadcrumb/arrow-left.svg" class="breadcrumb-block__divisor" />
          {{ lastElement.name }}
        </ZLink>
      </li>
    </ul>
  </div>
</template>
<script>
import { getSubMenuAllLinks } from '~/assets/js/utils/submenu';
import { ZLink } from '@quero/zilla-vue';

export default {
  components: {
    ZLink,
  },
  props: {
    'listBreadcrumb': Array
  },
  computed: {
    allLinks() {
      return this.listBreadcrumb ? this.listBreadcrumb : getSubMenuAllLinks('manual');
    },
    lastElement() {
      return this.allLinks.filter(el => el.current === false).pop() || '';
    }
  }
}
</script>

<style scoped lang="scss">
  @import '@quero/zilla-core/src/utils/functions.scss';
  @import '@quero/zilla-core/src/utils/variables.scss';

  .breadcrumb-block {
    display: flex;
    margin-bottom: $space-m;

    @media (min-width: $screen-md-min) {
      margin-bottom: $space-st;
    }
  }

  .breadcrumb-block--no-margin {
    margin-bottom: 0;
  }

  .breadcrumb-block__list {
    list-style-type: none;
    margin-bottom: 0;
    padding: 0;
  }

  .breadcrumb-block__list-item {
    float: left;
  }

  .breadcrumb-block__list-item__link {
    color: var(--color-neutral-gray-light);
    font-size: rem(16);
    font-size: rem(13);

    &:hover {
      text-decoration: none;
    }
  }

  .breadcrumb-block__list-item__link--no-active {
    color: var(--color-brand-primary-pure);
    font-weight: bold;
  }

   .breadcrumb-block__list-item--active {
    color: var(--color-neutral-gray-darker);
    font-size: rem(16);
    font-size: rem(13);
  }

  .breadcrumb-block__divisor {
    color: var(--color-neutral-gray-darker);
    font-size: rem(13);
    height: 20px;
    line-height: 1.54;
    margin: $space-s;
    width: 5px;
  }
</style>
